





























































import { Component, Vue, Watch, Prop } from "vue-property-decorator"

@Component
export default class BusinessGetStartedLegalDocs extends Vue {
  @Prop({ default: 0, type: Number }) readonly activeTabId!: number;

  isMounted = false

  termsAndConditions = ""
  privacyStatement = ""
  privacyPolicy = ""

  isApiFetch = {
    tc: false,
    pp: false,
    ps: false,
  }

  beforeMount() {
     this.$store
      .dispatch("Document/fetch", "terms-and-conditions")
      .then((response) => {
        this.termsAndConditions = response.data.data
        this.isApiFetch['tc'] = true
      })
    this.$store
      .dispatch("Document/fetch", "privacy-statement")
      .then((response) => {
        this.privacyStatement = response.data.data
        this.isApiFetch['ps'] = true
      })
    this.$store
      .dispatch("Document/fetch", "privacy-policy")
      .then((response) => {
        this.privacyPolicy = response.data.data
        this.isApiFetch['pp'] = true
      })
  }

  @Watch("isApiFetch", { deep: true })
  watchIsApiFetch(newVal) {
    if (newVal) {
      let isFinished = true
      for (const [key, value] of Object.entries(this.isApiFetch)) {
        if (!value) {
          isFinished = false
        }
      }
      if (isFinished) {
        this.isMounted = true
      }
    }
  }
}
